
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return !/^webpack_sharing_consume_default_(squiz_(dxp\-(ai\-client_squiz_dxp\-ai\-client\-webpack_sharing_consu\-8d622b|console\-support_squiz_dxp\-console\-support\-webpack_s\-6926dd)|sds_squiz_sds)|clsx_clsx|date\-fns_date\-fns\-webpack_sharing_consume_default_react\-route\-6d8c51|react\-dom_react\-dom|rxjs_rxjs)$/.test(chunkId);
},
rootOutputDir: "",

    };
}
